export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-v1-1200-cf238945273c040cdbff9dc876539f8c.png";